import { set } from "lodash";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { api } from "src/_cores/_api/api";
import { ROLE_KEY } from "src/_cores/_constants/role-constants";
import { COMMON_API_URL } from "src/_cores/_enums/api-url.enum";
import { showSuccess } from "src/_cores/_reducers/alert.reducer";
import { setProductDetail } from "src/_cores/_reducers/product.reducer";
import ProductService from "src/_cores/_services/product.service";
import { useAuthStore } from "src/_cores/_store/root-store";
import { IUserComment } from "src/_pages/product-detail/_interfaces/comment.interface";
import { MuiIcon } from "src/_shares/_components";
import UploadInput from "src/_shares/_components/input/upload-input";
import { ICON_NAME } from "src/_shares/_components/mui-icon/_enums/mui-icon.enum";
import { DateTimeHelper } from "src/_shares/_helpers/datetime-helper";

const UserComment = (props: IUserComment) => {
    const authStore = useAuthStore();
    const fileInputRef = useRef<any>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const productId = Number(searchParams.get('id')) || -1;
    const { id, type, data } = props;
    const [enableActions, setEnableActions] = useState<boolean>(false);
    const [editMode, setEditMode] = useState<'' | 'reply' | 'edit'>('');
    const [likeDislike, setLikeDislike] = useState<'' | 'like' | 'dislike'>('');
    const [updateId, setUpdateId] = useState<number | null>(null);
    const [selectedStar, setSelectedStar] = useState<number>(0);
    const [comment, setComment] = useState<string>('');
    const [fileNames, setFileNames] = useState<string[]>([]);
    const dispatch = useDispatch();


    const onEnableEditMode = (mode: 'reply' | 'edit') => {
        setEditMode(mode);
        setEnableActions(false);
        if (mode === 'edit') {
            setUpdateId(data?.id || null);
            setComment(data?.comment || '');
            setSelectedStar(data?.value || 0);
        }
    }

    const onDisableEdit = () => {
        setEditMode('');
        setComment('');
        setEnableActions(false);
    }

    const toggleLikeDislike = (val = '' as '' | 'like' | 'dislike') => {
        if (val === likeDislike) {
            setLikeDislike('');
        } else {
            setLikeDislike(val);
        }
    }

    const onUpload = (e: any) => {
        setFileNames(e);
    }

    const onSelectStar = (index: number) => {
        setSelectedStar(index);
    }

    const onSubmitComment = async () => {
        const params = {
            id: updateId,
            comment: comment,
            productId: productId,
            value: selectedStar,
            fileNames: fileNames,
        }
        const res = await api.post('/comment/post', params) as any;
        if (res?.isSucceed) {
            dispatch(showSuccess(updateId ? 'Cập nhật thành công' : 'Gửi bình luận thành công!'))
            // reset data
            resetOnSubmit();

            fileInputRef.current?.removeSelectedFiles();
        }
    }

    const onReplyComment = async () => {
        const params = {
            comment: comment,
            repliedId: data?.id,
            userRepliedId: data?.userId,
            fileNames: fileNames,

            value: selectedStar,
        }
        const res = await api.post('/comment/reply', params) as any;
        if (res?.isSucceed) {
            dispatch(showSuccess('Gửi trả lời thành công!'));
            // reset data
            resetOnSubmit();
        }
    }

    const onDeleteComment = async () => {
        if (!window.confirm('Bạn có chắc muốn xóa bình luận này?')) {
            return;
        }
        const res = await api.post('/comment/delete?id=' + data?.id) as any;
        if (res?.isSucceed) {
            dispatch(showSuccess('Xóa bình luận thành công!'));
            // reset data
            resetOnSubmit();
        }
    }

    const resetOnSubmit = () => {
        // reset data
        setEditMode('');
        setComment('');
        setFileNames([]);
        setSelectedStar(0);
        setUpdateId(null);

        setEnableActions(false);

        ProductService.getProductDetail(productId).then((res) => {
            if (res.data) {
                dispatch(setProductDetail(res.data));
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    return (
        <div className={type === 'reply' ? 'reply mb-2' : 'mb-4'}>
            {type !== 'post' && (
                <div className="flex items-center justify-between flex-wrap">
                    <div className="flex items-center mb-2">
                        <span className="user__comment-name mr-2">
                            <strong>{data?.fullName}</strong>
                        </span>
                        {data?.isAdmin && (
                            <span
                                className="user__comment-role px-1 mr-2"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                Quản trị viên
                            </span>
                        )}
                    </div>
                    <span
                        className="user__comment-time ml-2 mb-2"
                        style={{ whiteSpace: "nowrap" }}
                    >
                        {DateTimeHelper.getDateTimeFormated(data?.createDate)}
                    </span>
                </div>
            )}
            {/* STAR LV1 */}
            {['post', 'comment'].includes(type) && (
                <div className="flex stars">
                    {(type === 'post' || editMode === 'edit') && (
                        <span className="mr-2">Đánh giá</span>
                    )}
                    {!data?.parentId && (
                        [...Array(5)].map((_, index) => (
                            <MuiIcon
                                key={index}
                                name={ICON_NAME.FEATHER.STAR}
                                style={{ fontSize: "1.4rem" }}
                                className={(type === 'post' || editMode === 'edit') ? 'cursor-pointer' : ''}
                                fill={
                                    index < ((type === 'post' || editMode === 'edit') ? selectedStar : (data?.value ?? 0))
                                        ? 'orange'
                                        : 'none'
                                }
                                onClick={() => (type === 'post' || editMode === 'edit') && onSelectStar(index + 1)}
                            />
                        ))
                    )}
                </div>
            )}
            {/* View Only */}
            {type !== 'post' && (<>
                {editMode !== 'edit' && (
                    <div>
                        {/* COMMENT LV1 */}
                        <div className="comment my-2">
                            {data?.repliedFullName && <span style={{ color: "#288ad9" }}>@{data?.repliedFullName} </span>}
                            {data?.comment}
                        </div>
                        {/* IMAGES LV1 */}
                        {data?.images && data.images.length > 0 && (
                            <div className="image images-comment mb-2">
                                <ul className="image-list flex">
                                    {data.images.map((img: any, index: number) => (
                                        <li className="border">
                                            <img
                                                src={process.env.REACT_APP_IMAGE_URL + '/rates/' + img}
                                                alt="Ảnh của bạn"
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
                {!editMode && (
                    <div className="flex items-center mb-2 reply-action action-box">
                        <div
                            className="mr-2"
                            style={{ color: "#288ad9", cursor: "pointer" }}
                            onClick={() => onEnableEditMode('reply')}
                        >
                            Trả lời
                        </div>
                        {/* LIKE */}
                        {/* <div
                        className="favor flex items-center"
                        style={{
                            cursor: "default",
                            marginRight: "5px",
                            height: "18px",
                            color: "#288ad9",
                        }}
                    >
                        <MuiIcon
                            name={ICON_NAME.FEATHER.THUMBS_UP}
                            className="cursor-pointer"
                            fill={likeDislike === 'like' ? 'currentColor' : 'none'}
                            onClick={() => toggleLikeDislike('like')}
                        />
                        <span className="user__comment-time ml-2 like count" style={{ color: "#707070" }}>
                            10
                        </span>
                    </div> */}
                        {/* DISLIKE */}
                        {/* <div
                        className="favor flex items-center"
                        style={{
                            cursor: "default",
                            marginRight: "5px",
                            height: "18px",
                            color: "#288ad9",
                        }}
                    >
                        <MuiIcon
                            name={ICON_NAME.FEATHER.THUMBS_DOWN}
                            className="cursor-pointer"
                            fill={likeDislike === 'dislike' ? 'currentColor' : 'none'}
                            onClick={() => toggleLikeDislike('dislike')}
                        />
                        <span
                            className="user__comment-time ml-2 dislike count"
                            style={{ color: "#707070" }}
                        >
                            5
                        </span>
                    </div> */}
                        {/* More actions */}
                        {(authStore.user?.id === data?.userId || authStore.user?.role === ROLE_KEY.ADMIN) && (
                            <div style={{ position: "relative" }}>
                                <div
                                    className="favor flex items-center h-[18px] mr-[5px]"
                                    onClick={() => setEnableActions(toggle => !toggle)}
                                >
                                    <span
                                        className="feather feather-more-horizontal"
                                        style={{
                                            borderRadius: "50%",
                                            background: "#ddd",
                                            border: "1px solid #ddd",
                                            padding: "3px",
                                            position: "relative",
                                            width: "27px",
                                            height: "24px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <MuiIcon
                                            name="MORE_HORIZ"
                                            style={{
                                                position: "absolute",
                                                top: "0",
                                                left: "0",
                                            }}
                                        />
                                    </span>
                                </div>
                                {enableActions && (
                                    <div
                                        className={`action-list`}
                                        style={{
                                            position: "absolute",
                                            width: "126px",
                                            background: "#fff",
                                            border: "1px solid #ddd",
                                            borderRadius: "10px",
                                            top: "24px",
                                            left: "5px",
                                            zIndex: "1",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <ul className="text-center">
                                            <li className="border-bottom">
                                                <span className="text-[var(--blue-dior)]" onClick={() => onEnableEditMode('edit')}>Chỉnh sửa</span>
                                            </li>
                                            <li className="border-bottom">
                                                <span className="text-[red]" onClick={onDeleteComment}>Xóa</span>
                                            </li>
                                            <li>
                                                <span onClick={() => setEnableActions(false)}>Hủy</span>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </>)}
            {(editMode || type === 'post') && (<>
                <div className="flex mt-2">
                    <textarea
                        name=""
                        id=""
                        placeholder="Bình luận"
                        className="flex w-full mb-2 rep-comment-val-lv1"
                        value={comment}
                        onChange={(event) => setComment(event.target.value)}
                    ></textarea>
                </div>
                <div className="text-left">
                    <div className="upload-image mb-2 mt-2">
                        <UploadInput
                            id={id}
                            ref={fileInputRef}
                            multiple
                            hidden
                            onChangeFiles={onUpload}
                            uploadType="rates"
                        />
                    </div>
                </div>
                <div className="text-right flex justify-end ">
                    {type !== 'post' && (
                        <input
                            type="button"
                            value="Hủy"
                            className="cursor-pointer"
                            style={{
                                padding: "6px 11px",
                                backgroundColor: "#unset",
                                border: "1px solid #333",
                                color: "#333",
                                marginRight: "4px",
                            }}
                            onClick={onDisableEdit}
                        />
                    )}
                    {/* Submit new */}
                    {type === 'post' && (
                        <button type="button" onClick={onSubmitComment}>
                            Gửi bình luận
                        </button>
                    )}
                    {/* Update */}
                    {editMode === 'edit' && (
                        <button type="button" onClick={onSubmitComment}>
                            Cập nhật
                        </button>
                    )}
                    {/* Reply */}
                    {editMode === 'reply' && (
                        <button type="button" onClick={onReplyComment}>
                            Trả lời
                        </button>
                    )}
                </div>
            </>)}
        </div>
    )
};

export default UserComment;